export default __webpack_public_path__ + "720ee9430ee2dbf6cf7da61a033ba16a.woff2";